module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4bfa4db4f366febfd0a820b1655623dc.png";